import React from 'react';
import { AppBar, Toolbar } from '@mui/material';

const CommonAppBar = ({
  leftGap = '60px',
  top = 63,
  section,
  height,
}) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${leftGap})`,
        ml: leftGap,
        top,
        backgroundColor: '#fff',
        color: '#333',
        boxShadow: '0px 0px 0px 0px #fff',
        zIndex: 15,
        height: height ? height : 55,
      }}>
      <Toolbar sx={{ px: 3, minHeight: 'auto', mt: -0.5 }}>
        {section}
      </Toolbar>
    </AppBar>
  );
};

export default CommonAppBar;
